<template >
  <gat-flex  class="mb-1" :hide="hideValue" :size="size||'s'">
    <gat-field-spacer :size="size">
      <div class="compactLabel grey--text" >{{label}}</div>

      <v-icon v-if="checkbox" class="mr-1">{{formatedValue()}}</v-icon>

      <a v-else-if="linkUrl" class="gridLink text-truncate mr-2" :href="linkUrl" :target="linkTarget" >{{formatedValue()}}</a>

      <div v-else class=" text-truncate mr-2">
        <v-icon :color="iconColor" small v-if="prependIcon" class="mr-1">{{prependIcon}}</v-icon>
        {{formatedValue()}}
      </div>
    </gat-field-spacer>
  </gat-flex>
</template>

<script>
import GatFieldSpacer from './GatFieldSpacer.vue'
 import GatFlex from './GatFlex.vue';
 import GatUtils from './GatUtils.js';

  export default {
    name: 'GatCompactField',
    props: ['value','label','size','isDate','isDateTime','prepend-icon','icon-color','link-url','link-target','checkbox','hide'],
    components: {GatFlex,GatFieldSpacer},
    data: function() {
      return	{

      }
    },

    created(){
    },


    watch:{
    },

    computed:{
      hideValue(){
        if(!this.value){
          return 'all';
        } else {
          return this.hide;
        }
      }
    },

    methods:{
      formatedValue(){
        let result = this.value;
        if(this.isDateTime){
          result = GatUtils.formatDateTime(result);
          // eslint-disable-next-line 
        } else if((typeof result  == 'Date')||this.isDate){
          result = GatUtils.formatDate(result);
        }
        if(this.checkbox){
          if(this.value){
            result = 'check'
          }
        }
        return result;
      }
    },
  }
</script>

<style scoped>
  .compactLabel{
    /* color: rgba(0,0,0,.54); */
    font-size: 75%;
  }

</style>
